import {APIGET, APIPOST} from "../utils/apiHelper";
import i18n from "../i18n";

// initial state
const state = {
  damageData: [],
  damageDataLocal: [
    {
      "SCREEN": {
        "data": [
          {
            "damageTypeId": "1",
            "damageStatusId": "1",
            "damageStatusName": "Törött kijelző",
            "damageStatusHint": "Törött a kijelző, ha jól látható, tapintható törés, repedés vagy mély karc van rajta."
          },
          {
            "damageTypeId": "1",
            "damageStatusId": "2",
            "damageStatusName": "Karcos/beégett kijelző",
            "damageStatusHint": "Karcos a kijelző ha a mindennapi használatból adódó, jól látható karcok vannak rajta. A kijelző nagy részén, vagy elszórtan beégés látható."
          },
          {
            "damageTypeId": "1",
            "damageStatusId": "3",
            "damageStatusName": "Tökéletes kijelző",
            "damageStatusHint": "Tökéletes a kijelző, ha semmilyen karc vagy törés nincs rajta, és nincs rajta szemmel látható elváltozás."
          }
        ],
        "damageTypeName": "Kijelző"
      }
    },
    {
      "BATTERY": {
        "data": [
          {
            "damageTypeId": "2",
            "damageStatusId": "4",
            "damageStatusName": "Akkumulátor hibás",
            "damageStatusHint": "Rossz az akkumulátor ha a készülék csak töltőn tud működni. vagy ha készenléti állapotban maximum 30 percet bír ki, vagy aktív használat alatt 10 percen belül lemerül."
          },
          {
            "damageTypeId": "2",
            "damageStatusId": "5",
            "damageStatusName": "Akkumulátor gyorsan lemerül",
            "damageStatusHint": "Gyorsan lemerül az akkumulátor, ha készenléti állapotban kevesebb mint 12 órát bír ki, vagy aktív használat alatt 1 óra alatt lemerül."
          },
          {
            "damageTypeId": "2",
            "damageStatusId": "6",
            "damageStatusName": "Akkumulátor jó",
            "damageStatusHint": "Jó az akkumulátor, ha készenléti állapotban minimum egy napot kibír, vagy aktív használat közben minimum 4 órát kibír, és a megszokott módon lehet tölteni."
          }
        ],
        "damageTypeName": "Akkumulátor"
      }
    },
    {
      "COVER": {
        "data": [
          {
            "damageTypeId": "3",
            "damageStatusId": "7",
            "damageStatusName": "Hátlap/keret törött",
            "damageStatusHint": "A hátlap vagy a keret törött, ha jól látható, tapintható törés, repedés vagy mély karc van rajta."
          },
          {
            "damageTypeId": "3",
            "damageStatusId": "8",
            "damageStatusName": "Hátlap/keret karcos",
            "damageStatusHint": "A hátlap vagy a keret karcos, ha a mindennapi használatból adódó, jól látható karcok vannak rajta."
          },
          {
            "damageTypeId": "3",
            "damageStatusId": "9",
            "damageStatusName": "Hátlap/keret jó",
            "damageStatusHint": "A hátlap/keret megfelelő, ha a készülék újszerű állapotban van, vagy kevés, mindennapi használatból eredő apró nyom van."
          }
        ],
        "damageTypeName": "Hátlap/Keret"
      }
    },
    {
      "DEVICE_STATUS": {
        "data": [
          {
            "damageTypeId": "4",
            "damageStatusId": "10",
            "damageStatusName": "Nem kapcsolható be",
            "damageStatusHint": "A telefon nem bekapcsolható, vagy az általános rendszerfunkciók nem működnek."
          },
          {
            "damageTypeId": "4",
            "damageStatusId": "11",
            "damageStatusName": "Gyakran lefagy/kikapcsol",
            "damageStatusHint": "A készülék gyakran lefagy vagy kikapcsol, ha aktív használat során egy órán belül legalább egyszer lefagy/kikapcsol."
          },
          {
            "damageTypeId": "4",
            "damageStatusId": "12",
            "damageStatusName": "Bekapcsolható és hibátlanul működik",
            "damageStatusHint": "Bekapcsolható és hibátlanul működik a telefon, ha bekapcsolható, tölthető, váratlanul sem áll le, minden rendszerfunkció rendeltetésszerűen működik és a készüléken a gyári operációs rendszer fut."
          }
        ],
        "damageTypeName": "Készülék állapota"
      },
      "NETWORK_LOCK_TYPE": {
        "data": [
          {
            "networkLockTypeId": "1",
            "networkLockTypeName": "Hálózatfüggő",
            "networkLockTypeHint": "Igen, a készülékem Vodafone, Telekom, Telenor vagy más hálózat függő."
          },
          {
            "networkLockTypeId": "2",
            "networkLockTypeName": "Hálózatfüggetlen",
            "networkLockTypeHint": "Nem, a készülékem független minden hálózattól."
          }
        ],
        "networkLockName": "Hálózati zár"
      }
    }
  ],
  calcDataId: null,
  customerId: null,
  // calcData: null,
  calcData: {
    deviceName: 'Apple iPhone 8',
  },
  customerData: null,
};

// getters
const getters = {
  //
};

// actions
const actions = {
  async getDamageData(context, lang = 'hu') {
    const response = await APIGET(`general-management/damage-data/${lang}`);
    switch (response.status) {
      case 200:
        context.commit('setDamageData', response.data);
        break;
      case 400:
        context.commit('setDamageData', context.state.damageDataLocal);
        break;
      case 404:
        context.commit('setDamageData', context.state.damageDataLocal);
        break;
      case 500:
        context.commit('setDamageData', context.state.damageDataLocal);
        break;
      default:
        context.commit('setDamageData', context.state.damageDataLocal);
        break;
    }
    return response.status;
  },
  async preOfferAcception(context, hash) {
    let lang = i18n.locale.substring(0, 2);
    const response = await APIGET(`general-management/preoffer-acception/${hash}/${lang}`);
    if (response.status === 200) {
      // context.commit('setOfferCalcDataId', response.data.calcDataId);
      // context.commit('setCustomerId', response.data.customerId);
      context.commit('setCustomerData', response.data);
    }
    return response.status;
  },
  async getCalcData(context) {
    let lang = i18n.locale.substring(0, 2);
    const response = await APIGET(`general-management/calc-data/${context.state.customerData.calcDataId}/${lang}`);
    if (response.status === 200) {
      context.commit('setCalcData', response.data);
    }
    return response.status;
  },
  async getLastFourDeviceData(context) {
    let lang = i18n.locale.substring(0, 2);
    return await APIGET(`general-management/device-data-last-four/${lang}`);
  },
  async offerAcception(context, hash) {
    let lang = i18n.locale.substring(0, 2);
    const response = await APIGET(`general-management/offer-acception/${hash}/${lang}`);
    return response.status;
  },
  async offerRejection(context, hash) {
    let lang = i18n.locale.substring(0, 2);
    const response = await APIGET(`general-management/offer-rejection/${hash}/${lang}`);
    return response.status;
  },
  async getCampaignDeviceTypes(context, credentials) {
    const response = await APIGET('campaign-device-types',);
    return response.data;
  },
};

// mutations
const mutations = {
  setDamageData(state, payload) {
    state.damageData = payload;
  },
  setOfferCalcDataId(state, payload) {
    state.calcDataId = payload;
  },
  setCustomerId(state, payload) {
    state.customerId = payload;
  },
  setCalcData(state, payload) {
    state.calcData = payload;
  },
  setCustomerData(state, payload) {
    state.customerData = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
